import React from "react";
import styled, { css } from "styled-components";

import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal";
import { Button } from "src/library/components/Button";
import { Text } from "src/library/components/Text";

interface UnsavedDashboardChangesModelProps extends Pick<BasicModalProps, "onDismiss" | "open"> {
  onConfirm: () => void;
}

// Basic model checking user wants to continue without saving dashboard changes
export const UnsavedDashboardChangesModel: React.ReactFCWithChildren<UnsavedDashboardChangesModelProps> = ({
  onDismiss, open, onConfirm
}) => {
  return (
    <StyledBasicModal
      title="Unsaved Dashboard Changes"
      open={open}
      onDismiss={onDismiss}
    >
      <Text>
        Are you sure you want to leave without saving your changes?
      </Text>

      <div className="action-buttons">
        <Button
          $buttonType="secondary"
          onClick={onDismiss}
        >
          Go Back
        </Button>

        <Button
          $buttonType="primary"
          onClick={onConfirm}
        >
          Yes
        </Button>
      </div>
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  ${({ theme }) => css`    
    .action-buttons {
      margin-top: ${theme.spacing.margins.lg};
      display: flex;
      justify-content: space-between;
    }
  `}
`;
